import React from "react";
import * as styles from "../link/link.module.scss";

/**
 * @type {Object} 「UI:atoms - ボタンリンク CV用 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} url ボタンリンクに設定するURLに値する文字列です。
 * @param {Array} label ボタンリンクに設定するラベルに値する文字列です。
 *
 */

const ButtonCv = ({ url, label }) => {
  return (
    <span className={`${styles.buttonBase} ${styles.cv}`}>
      {url.substring(0, 1) === "/" ? (
        <a href={url}>{label}</a>
      ) : (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      )}
    </span>
  );
};

export default ButtonCv;
